import React, { Dispatch, SetStateAction } from "react";
import { IDeclaration } from "../../exports/interfaces";
// import { dynamicSuccess } from "../../hooks/useToast";

const Declaration = ({
  declaration,
  setDeclaration,
  errors,
}: {
  declaration: IDeclaration;
  setDeclaration: Dispatch<SetStateAction<IDeclaration>>;
  errors: Record<string, string>;
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    let updatedValue = value;

    if (name === "mobile") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    setDeclaration((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? String(checked) : updatedValue,
    }));
  };

  return (
    <div className="dashboard-card">
      <div className="row gx-5 gy-4">
        <div className="col-md-4">
          <label className="form-label">
            Name <span className="primary-color">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${errors.name ? "input-error" : ""}`}
            placeholder="Enter Name"
            name="name"
            value={declaration.name}
            onChange={handleChange}
          />
          {errors.name && <p className="error-message">{errors.name}</p>}
        </div>

        <div className="col-md-4">
          <label className="form-label">
            Position <span className="primary-color">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${errors.position ? "input-error" : ""}`}
            placeholder="Enter Position"
            name="position"
            value={declaration.position}
            onChange={handleChange}
          />
          {errors.position && (
            <p className="error-message">{errors.position}</p>
          )}
        </div>

        <div className="col-md-4">
          <label className="form-label">
            Mobile Number <span className="primary-color">*</span>
          </label>
          <input
            type="text"
            inputMode="numeric"
            pattern="\d*"
            maxLength={10}
            className={`form-control ${errors.mobile ? "input-error" : ""}`}
            placeholder="Enter Mobile Number"
            name="mobile"
            value={declaration.mobile}
            onChange={handleChange}
          />
          {errors.mobile && <p className="error-message">{errors.mobile}</p>}
        </div>

        <div className="col-12">
          <label className="form-label">
            Declaration <span className="primary-color">*</span>
          </label>

          <p className="text-muted small mb-2 fst-italic">
            Check all that apply.
          </p>

          <div className="table-checkbox d-flex align-items-center gap-2">
            <input
              type="checkbox"
              id="declaration"
              name="declaration"
              checked={declaration.declaration === "true"}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="declaration">
              I hereby declare that the information provided is true and
              correct.
            </label>
          </div>
          {errors.declaration && (
            <p className="error-message">{errors.declaration}</p>
          )}
        </div>

        {/* <div className="col-12 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-badge-primary px-4"
            onClick={() => {
              localStorage.setItem("declaration", JSON.stringify(declaration));
              dynamicSuccess("Declaration saved as draft!");
            }}
          >
            Save
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Declaration;
